import { render } from "./CadastroFinalizacao.vue?vue&type=template&id=20418e2e"
import script from "./CadastroFinalizacao.vue?vue&type=script&lang=js"
export * from "./CadastroFinalizacao.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__